import { View } from 'react-native'
import styled from 'styled-components'
import TouchableNoFeedback from '../../../../../elements/controls/TouchableNoFeedback/TouchableNoFeedback'
import Image from '../../../../../elements/images/Image/Image'
import { Text } from '../../../../../elements/typography'
import { cursorPointer } from '../../../../../style/webStyles'

const WIDTH = 120

const Card = styled(TouchableNoFeedback)`
  width: ${WIDTH}px;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.7);
  margin-bottom: ${(props) => props.theme.spacing.sm}px;
  margin-right: ${(props) => props.theme.spacing.md}px;
  ${cursorPointer};
`

const Description = styled(View)`
  flex-grow: 1;
  padding: ${(props) => props.theme.spacing.sm}px;
`

const Name = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.medium}px;
  margin-bottom: ${(props) => props.theme.spacing.xsmall}px;
`

const Role = styled(Name)`
  color: #ababab;
`

export const FeaturedActorCard = ({ slug, title, role, publicId, onActorSelect }) => (
  <Card onPress={() => onActorSelect(slug)}>
    <Image publicId={publicId} width={WIDTH} height={WIDTH * 1.5} />

    <Description>
      <Name>{title}</Name>
      <Role>{role}</Role>
    </Description>
  </Card>
)
